import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// ภาษาของ mini site นี้แยกจาก i18next ของระบบหลัก — เลือกด้วย ?lang=en (แชร์ลิงก์ได้) และจำค่าไว้ต่อเครื่อง
export const LANGS = ["th", "en"];
const LANG_PREF = "bce_lang";

const readPref = () => {
  try {
    return window.localStorage.getItem(LANG_PREF);
  } catch (e) {
    return null;
  }
};

const STRINGS = {
  th: {
    brandSub: "Exhibition",
    navBags: 'ถุง"ไทยเท่"',
    navMap: "แผนที่ประเทศไทย",
    navGallery: "คอลเลกชัน",
    navStory: "เรื่องราวบนถุง",
    menuLabel: "เมนูนิทรรศการ",
    langSwitch: "EN",
    langSwitchLabel: "Switch to English",
    collection: "Collection",
    play360: "ชมแบบ 360°",
    stopRotate: "หยุดหมุน",
    reducedMotion: "ปิดไว้ตามการตั้งค่าลดการเคลื่อนไหวของอุปกรณ์",
    zoomDetail: "ซูมดูรายละเอียด",
    exploreHotspots: "สำรวจจุดเด่นบนลวดลาย",
    storyInspiration: "เรื่องราวและแรงบันดาลใจ",
    viewArtwork: "⛶ ดู Artwork ต้นฉบับ",
    viewerLabel: (p, v) => `ถุง${p} — ลากหรือใช้ปุ่มลูกศรซ้าย/ขวาเพื่อหมุน กำลังแสดง${v}`,
    rotateLeft: "หมุนไปทางซ้าย",
    rotateRight: "หมุนไปทางขวา",
    loading: "กำลังโหลด Artwork…",
    loadError: "โหลดภาพ Artwork ไม่สำเร็จ",
    retry: "ลองอีกครั้ง",
    rotateHint: "ลากเพื่อหมุนดู",
    showGuide: "วิธีหมุนถุง",
    chooseSide: "เลือกด้านของถุง",
    shrink: "ซูมออก",
    zoomControls: "ซูมถุง",
    resetSize: "กลับขนาดปกติ",
    enlarge: "ซูมเข้า",
    hideHotspots: "ซ่อนจุดเด่น",
    showHotspots: "แสดงจุดเด่น",
    hotspotLabel: (t) => `จุดเด่น: ${t}`,
    guideTitle: "หมุนดูถุงได้รอบทิศ",
    guideDrag: "ลากซ้าย–ขวาบนถุง (หรือปัดบนมือถือ)",
    guideArrows: "กดปุ่ม ‹ › หรือลูกศรบนคีย์บอร์ด",
    guideSides: "เลือกด้านจากปุ่มด้านล่าง",
    guideZoom: "ซูมที่ถุงด้วยปุ่ม ＋ สองนิ้ว หรือดับเบิลคลิก แล้วแตะจุด ＋ เพื่อดูว่าคืออะไร",
    zoomPanHint: "ลากเพื่อเลื่อนดู · ดับเบิลคลิกหรือกด ⟲ เพื่อกลับ",
    guideOk: "เข้าใจแล้ว",
    storyTitle: "เรื่องราวบนถุงใบนี้",
    storySub: "Story Behind the Bag",
    highlights: "จุดเด่นบนลวดลาย",
    noHotspots: "กำลังเตรียมข้อมูลจุดเด่นของถุงใบนี้ ระหว่างนี้หมุนและซูมดูลวดลายได้เลย",
    selectHint: "แตะจุดเด่นด้านบน หรือกด “ซูมดูรายละเอียด” เพื่อดูตำแหน่งบนลายถุง",
    viewing: "✓ กำลังดู · ",
    placeholderTeaser: (p) => `ถุงช้อปปิ้ง Big C ลายจังหวัด${p}`,
    placeholderStory: (p) =>
      `ลวดลายรอบถุงทั้ง 5 ด้านถ่ายทอดเอกลักษณ์ของจังหวัด${p} หมุนและซูมเพื่อสำรวจรายละเอียดบนถุงได้`,
    galleryIntro: (n) => `สำรวจคอลเลกชันถุงช้อปปิ้งจาก ${n} แบบ ทั่วไทย`,
    searchPlaceholder: "ค้นหาจังหวัด เช่น เชียงใหม่ / Phuket",
    searchLabel: "ค้นหาจังหวัด",
    filterLabel: "กรองตามภูมิภาค",
    all: "ทั้งหมด",
    nowViewing: "กำลังชม",
    notFound: "ไม่พบจังหวัดที่ค้นหา",
    zoomDialog: (p) => `ซูมดู Artwork ถุง${p}`,
    zoomTabs: "เลือกภาพที่จะซูม",
    originalArtwork: "Artwork ต้นฉบับ",
    originalArtworkCaption: "Artwork ต้นฉบับ (ภาพกางถุง)",
    close: "✕ ปิด",
    closeTip: "ปิด",
    zoomIn: "ซูมเข้า",
    zoomOut: "ซูมออก",
    zoomReset: "รีเซ็ต",
    zoomResetLabel: "รีเซ็ตการซูม",
    zoomHelp: "แตะจุด ＋ เพื่อดูว่าคืออะไร · ใช้สองนิ้วหรือ scroll เพื่อซูม",
    mapTitle: 'แผนที่ถุง "ไทยเท่"',
    mapPageTitle: 'แผนที่ถุง "ไทยเท่" · Big C Shopping Bag Exhibition',
    mapIntro: (a, b, n) => `แตะหมุดหรือจังหวัดบนแผนที่เพื่อดูถุง · มีถุงแล้ว ${a} จาก ${b} จังหวัด (${n} แบบ)`,
    mapSearch: "ค้นหาจังหวัด",
    mapSearchLabel: "ค้นหาจังหวัดบนแผนที่",
    noBagYet: "ยังไม่มีถุง",
    mapAria: "แผนที่ประเทศไทย",
    provincesAria: "จังหวัดในประเทศไทย",
    pinLabel: (p, n) => `${p} — ถุง ${n} แบบ`,
    mapZoomIn: "ซูมเข้าแผนที่",
    mapZoomOut: "ซูมออกแผนที่",
    mapReset: "รีเซ็ตแผนที่",
    legendLabel: "สีตามภูมิภาค",
    watch360: "ชมถุงแบบ 360° ➜",
    noBagProvince: "ยังไม่มีถุงของจังหวัดนี้ในนิทรรศการ",
    otherInRegion: (r) => `ถุงจังหวัดอื่นใน${r}`,
    chooseProvince: "เลือกจังหวัด",
    chooseProvinceSub: "Explore by Map",
    mapHelp:
      "แตะหมุดสีแดงบนแผนที่เพื่อดูถุงของจังหวัดนั้น ตัวเลขบนหมุดคือจำนวนแบบถุงในจังหวัด ซูมด้วยปุ่ม ＋ หรือสองนิ้วเพื่อเลือกจังหวัดเล็ก ๆ รอบกรุงเทพฯ",
    pageTitle: (name) => `${name} · Big C Shopping Bag Exhibition`,
    exhibitAria: (p) => `นิทรรศการถุง${p}`,
  },
  en: {
    brandSub: "Exhibition",
    navBags: '"Thai Tae" Bags',
    navMap: "Thailand Map",
    navGallery: "Collection",
    navStory: "Bag Story",
    menuLabel: "Exhibition menu",
    langSwitch: "TH",
    langSwitchLabel: "เปลี่ยนเป็นภาษาไทย",
    collection: "Collection",
    play360: "View in 360°",
    stopRotate: "Stop rotating",
    reducedMotion: "Disabled by your device's reduced-motion setting",
    zoomDetail: "Zoom into details",
    exploreHotspots: "Explore highlights",
    storyInspiration: "Story & inspiration",
    viewArtwork: "⛶ View original artwork",
    viewerLabel: (p, v) => `${p} bag — drag or use the left/right arrow keys to rotate. Showing ${v}`,
    rotateLeft: "Rotate left",
    rotateRight: "Rotate right",
    loading: "Loading artwork…",
    loadError: "Couldn't load the artwork",
    retry: "Try again",
    rotateHint: "Drag to rotate",
    showGuide: "How to rotate",
    chooseSide: "Choose a side of the bag",
    shrink: "Zoom out",
    zoomControls: "Zoom the bag",
    resetSize: "Reset zoom",
    enlarge: "Zoom in",
    hideHotspots: "Hide highlights",
    showHotspots: "Show highlights",
    hotspotLabel: (t) => `Highlight: ${t}`,
    guideTitle: "Turn the bag all the way around",
    guideDrag: "Drag left–right on the bag (or swipe on mobile)",
    guideArrows: "Use the ‹ › buttons or your keyboard arrows",
    guideSides: "Jump to a side with the buttons below",
    guideZoom: "Zoom the bag with ＋, pinch or double-click, then tap a ＋ to see what it is",
    zoomPanHint: "Drag to pan · double-click or tap ⟲ to reset",
    guideOk: "Got it",
    storyTitle: "The Story on This Bag",
    storySub: "Story Behind the Bag",
    highlights: "Highlights on the Artwork",
    noHotspots: "Highlights for this bag are coming soon — rotate and zoom to explore the artwork.",
    selectHint: "Tap a highlight above, or open “Zoom into details” to see where it is on the bag.",
    viewing: "✓ Viewing · ",
    placeholderTeaser: (p) => `Big C shopping bag inspired by ${p}`,
    placeholderStory: (p) => `All five sides of this bag celebrate ${p}. Rotate and zoom to explore the details.`,
    galleryIntro: (n) => `Explore ${n} shopping bag designs from across Thailand`,
    searchPlaceholder: "Search a province, e.g. Phuket / เชียงใหม่",
    searchLabel: "Search province",
    filterLabel: "Filter by region",
    all: "All",
    nowViewing: "Viewing",
    notFound: "No matching province",
    zoomDialog: (p) => `Zoom into the ${p} bag artwork`,
    zoomTabs: "Choose an image to zoom",
    originalArtwork: "Original artwork",
    originalArtworkCaption: "Original artwork (flat layout)",
    close: "✕ Close",
    closeTip: "Close",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    zoomReset: "Reset",
    zoomResetLabel: "Reset zoom",
    zoomHelp: "Tap a ＋ to see what it is · Pinch or scroll to zoom",
    mapTitle: '"Thai Tae" Bag Map',
    mapPageTitle: '"Thai Tae" Bag Map · Big C Shopping Bag Exhibition',
    mapIntro: (a, b, n) => `Tap a pin or province to see its bag · ${a} of ${b} provinces (${n} designs)`,
    mapSearch: "Search province",
    mapSearchLabel: "Search a province on the map",
    noBagYet: "no bag yet",
    mapAria: "Map of Thailand",
    provincesAria: "Provinces of Thailand",
    pinLabel: (p, n) => `${p} — ${n} bag design${n > 1 ? "s" : ""}`,
    mapZoomIn: "Zoom in map",
    mapZoomOut: "Zoom out map",
    mapReset: "Reset map",
    legendLabel: "Colour by region",
    watch360: "View the bag in 360° ➜",
    noBagProvince: "This province doesn't have a bag in the exhibition yet.",
    otherInRegion: (r) => `Other bags in the ${r}`,
    chooseProvince: "Choose a province",
    chooseProvinceSub: "Explore by Map",
    mapHelp:
      "Tap a red pin to see that province's bag. The number on a pin is how many designs it has. Zoom with ＋ or pinch to reach the small provinces around Bangkok.",
    pageTitle: (name) => `${name} · Big C Shopping Bag Exhibition`,
    exhibitAria: (p) => `${p} bag exhibition`,
  },
};

export const CATEGORY_LABELS = {
  landmark: { th: "สถานที่สำคัญ", en: "Landmark" },
  identity: { th: "เอกลักษณ์เมือง", en: "City Identity" },
  product: { th: "ของดีประจำจังหวัด", en: "Local Specialty" },
};
export const CATEGORY_ORDER = ["landmark", "identity", "product"];

// ค่าข้อความของถุง/จุดเด่นตามภาษา (ไม่มีภาษาอังกฤษ → ใช้ภาษาไทย)
export const pick = (obj, field, lang) => (lang === "en" && obj[`${field}En`]) || obj[`${field}Th`];

export const provinceName = (c, lang) => (lang === "en" ? c.provinceEn : c.provinceTh);

export function useLang() {
  const [params, setParams] = useSearchParams();
  const fromUrl = params.get("lang");
  const lang = LANGS.includes(fromUrl) ? fromUrl : LANGS.includes(readPref()) ? readPref() : "th";

  const t = useCallback(
    (key, ...args) => {
      const v = STRINGS[lang][key] ?? STRINGS.th[key] ?? key;
      return typeof v === "function" ? v(...args) : v;
    },
    [lang]
  );

  const setLang = useCallback(
    (next) => {
      try {
        window.localStorage.setItem(LANG_PREF, next);
      } catch (e) {
        // ใช้ค่าใน URL ต่อได้
      }
      const p = new URLSearchParams(params);
      if (next === "th") p.delete("lang");
      else p.set("lang", next);
      setParams(p, { replace: true });
    },
    [params, setParams]
  );

  // คง ?lang=en ไว้เมื่อเปลี่ยนหน้า
  const withLang = useCallback((path) => (lang === "en" ? `${path}?lang=en` : path), [lang]);

  return { lang, t, setLang, withLang };
}
